import { Auth } from 'aws-amplify';
import AWSAppSyncClient, { AUTH_TYPE } from 'aws-appsync';

// FIXME: Missing library export
interface IdValue {
  type: 'id';
  id: string;
  generated: boolean;
  typename: string | undefined;
}
interface JsonValue {
  type: 'json';
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  json: any;
}
declare type ListValue = Array<null | IdValue>;
declare type StoreValue =
  | number
  | string
  | string[]
  | IdValue
  | ListValue
  | JsonValue
  | null
  | undefined
  | void
  | Object; //eslint-disable-line @typescript-eslint/ban-types
interface StoreObject {
  __typename?: string;
  [storeFieldKey: string]: StoreValue;
}
export interface NormalizedCacheObject {
  [dataId: string]: StoreObject;
}

/**
 * AWS Client
 *
 */

export async function configureAWS(): Promise<void> {
  const config = {
    region: import.meta.env.VITE_AWS_REGION,
    userPoolId: import.meta.env.VITE_AWS_USER_POOL_ID,
    userPoolWebClientId: import.meta.env.VITE_AWS_WEB_CLIENT_ID,
  };

  Auth.configure(config);
}

export async function initGraphQLApiClient(): Promise<AWSAppSyncClient<NormalizedCacheObject>> {
  const graphQlClient = new AWSAppSyncClient({
    url: import.meta.env.VITE_AWS_GRAPHQL_ENDPOINT as string,
    region: import.meta.env.VITE_AWS_REGION as string,
    auth: {
      type: AUTH_TYPE.AMAZON_COGNITO_USER_POOLS,
      jwtToken: async () => (await Auth.currentSession()).getAccessToken().getJwtToken(),
    },
    disableOffline: true,
  });

  // Note: AWS AppSync client doesn't have a direct errorHandler property
  // Session expiry handling is now done at the individual API call level
  // through the SessionExpiryHandler utility functions

  return await graphQlClient.hydrated();
}

export async function initGraphQLApiClientExtern(): Promise<AWSAppSyncClient<NormalizedCacheObject>> {
  const graphQlClient = new AWSAppSyncClient({
    url: import.meta.env.VITE_AWS_GRAPHQL_ENDPOINT as string,
    region: import.meta.env.VITE_AWS_REGION as string,
    auth: {
      type: AUTH_TYPE.API_KEY,
      apiKey: import.meta.env.VITE_AWS_API_KEY as string,
    },
    disableOffline: true,
  });

  return await graphQlClient.hydrated();
}
